<template>
  <button 
    v-show="showBackToTop"
    @click="scrollToTop"
    class="fixed bottom-6 right-6 w-12 h-12 rounded-full bg-black/70 text-white flex items-center justify-center cursor-pointer hover:bg-black transition-all duration-300 z-50"
    aria-label="回到顶部"
  >
    ↑
  </button>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue';

// 滚动位置状态
const scrollPosition = ref(0);

// 当滚动超过300px时显示回到顶部按钮
const showBackToTop = computed(() => scrollPosition.value > 300);

// 滚动到顶部的函数
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

// 处理滚动事件
const handleScroll = () => {
  scrollPosition.value = window.scrollY;
};

// 生命周期钩子
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
button {
  font-size: 1.5rem;
  border: none;
  outline: none;
}
</style>